import * as LabelPrimitive from "@radix-ui/react-label";
import cx from "ui/cx";
import IconInfoLine from "ui/icons/IconInfoLine";
import type { WithTooltipProps } from "ui/popovers/Tooltip";
import { wrapWithTooltip } from "ui/popovers/Tooltip";
import styles from "./Label.module.scss";

export interface LabelProps
  extends Omit<React.ComponentProps<typeof LabelPrimitive.Root>, "asChild">,
    WithTooltipProps {
  required?: boolean;
  disabled?: boolean;
}

export default function Label({
  children,
  className,
  tooltip,
  required = false,
  disabled = false,
  htmlFor,
  ...props
}: LabelProps) {
  return (
    <LabelPrimitive.Root
      className={cx(styles.root, disabled && styles.disabled, htmlFor && styles.clickable, className)}
      data-testid="label-element"
      htmlFor={!disabled ? htmlFor : undefined}
      data-disabled={disabled}
      {...props}
    >
      <span className={styles.content}>
        {children}
        {required && <span className={styles.requiredIndicator}>*</span>}
        {tooltip && wrapWithTooltip(<IconInfoLine className={styles.tooltipIcon} />, tooltip)}
      </span>
    </LabelPrimitive.Root>
  );
}
